import React from "react";
import IconImg from "../../asstes/reddit.png";
import moment from "moment";

function RedditCard({ data }) {
  //   console.log("Reddit card data>>>>>", data);
  function linkify(inputText) {
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(
      replacePattern1,
      '<a href="$1" target="_blank">$1</a>'
    );

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '$1<a href="http://$2" target="_blank">$2</a>'
    );

    //Change email addresses to mailto:: links.
    replacePattern3 =
      /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1">$1</a>'
    );

    return replacedText;
  }
  const thumb = data.data.thumbnail.slice(0, 5);
  return (
    <div className="react_card_wrapper relative">
      <div className="card_icon">
        <img src={IconImg} alt="Reddit" />
      </div>
      {thumb === "https" && (
        <div className="reddit_img">
          <img src={data.data.thumbnail} alt={data.data.title} />
        </div>
      )}
      <div
        className="reddit_body"
        dangerouslySetInnerHTML={{
          __html: linkify(data.data.title),
        }}
      />
      <div className="twitter_card_footer flex justify-between">
        <a
          href={`https://www.reddit.com/${data.data.permalink}`}
          target="_blank"
          className="twitter_button reddit_bg"
        >
          View Post
        </a>
        {/* <span className="date">{moment("", "YYYYMMDD").fromNow()}</span> */}
      </div>
    </div>
  );
}

export default RedditCard;
